// extracted by mini-css-extract-plugin
export default {"container":"links_container__u2mYe"};